function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import { Avatar, Message } from "@chatscope/chat-ui-kit-react";
import React, { useEffect, useRef, useState } from "react";
import { MessageDirection } from "../useChat";
import { convertToJapanTime } from "../utils/helpers";
export const CustomImageMessage = ({ message, user, direction, isFirstMessage = false, sendImageMessage }) => {
    var _a, _b, _c, _d, _e, _f;
    const _useState = useState(direction !== MessageDirection.Incoming), _useState2 = _slicedToArray(_useState, 2), isLoading = _useState2[0], setIsLoading = _useState2[1];
    const _useState3 = useState(""), _useState4 = _slicedToArray(_useState3, 2), imageUrl = _useState4[0], setImageUrl = _useState4[1];
    const messageRef = useRef(null);
    useEffect(() => {
        if (imageUrl && messageRef.current) {
            messageRef.current.scrollIntoView({
                behavior: "smooth"
            });
        }
    }, [imageUrl]);
    const imageFiles = Array.isArray(message.files) ? message.files.filter(Boolean) : [];
    if (direction === MessageDirection.Incoming) {
        return /*#__PURE__*/ React.createElement(Message, {
            model: {
                type: "image",
                payload: message.content,
                direction: direction,
                position: "normal"
            }
        }, /*#__PURE__*/ React.createElement(Message.Header, {
            "data-cs-first-message": isFirstMessage
        }, /*#__PURE__*/ React.createElement(Avatar, {
            src: ((_a = user === null || user === void 0 ? void 0 : user.profile) === null || _a === void 0 ? void 0 : _a.url_1) || ((_b = user === null || user === void 0 ? void 0 : user.profile) === null || _b === void 0 ? void 0 : _b.url_2) || ((_c = user === null || user === void 0 ? void 0 : user.profile) === null || _c === void 0 ? void 0 : _c.url_3)
        }, /*#__PURE__*/ React.createElement("img", {
            src: ((_d = user === null || user === void 0 ? void 0 : user.profile) === null || _d === void 0 ? void 0 : _d.url_1) || ((_e = user === null || user === void 0 ? void 0 : user.profile) === null || _e === void 0 ? void 0 : _e.url_2) || ((_f = user === null || user === void 0 ? void 0 : user.profile) === null || _f === void 0 ? void 0 : _f.url_3),
            alt: `user_img_${user === null || user === void 0 ? void 0 : user.id}`,
            onError: e => {
                e.target.src = "/images/fallback/default.png";
            }
        }))), /*#__PURE__*/ React.createElement(Message.CustomContent, null, /*#__PURE__*/ React.createElement("div", {
            style: {
                display: "flex",
                flexDirection: "row",
                gap: "8px"
            }
        }, imageFiles.map((file, index) => /*#__PURE__*/ React.createElement(Message.ImageContent, {
            key: index,
            src: file,
            alt: "image"
        })))), /*#__PURE__*/ React.createElement(Message.Footer, {
            sentTime: convertToJapanTime(message.createdTime)
        }));
    }
    if (!message.content || imageFiles.length > 0) {
        return /*#__PURE__*/ React.createElement(Message, {
            model: {
                type: "image",
                payload: message.content,
                direction: direction,
                position: "normal"
            }
        }, /*#__PURE__*/ React.createElement(Message.CustomContent, null, /*#__PURE__*/ React.createElement("div", {
            style: {
                display: "flex",
                flexDirection: "row",
                gap: "8px"
            }
        }, imageFiles.map((file, index) => /*#__PURE__*/ React.createElement(Message.ImageContent, {
            key: index,
            src: file,
            alt: "image"
        })))), /*#__PURE__*/ React.createElement(Message.Footer, {
            sentTime: convertToJapanTime(message.createdTime)
        }));
    }
    return /*#__PURE__*/ React.createElement(Message, {
        model: {
            type: "custom",
            payload: message.content,
            direction: direction,
            position: "normal"
        }
    }, /*#__PURE__*/ React.createElement(Message.CustomContent, null, /*#__PURE__*/ React.createElement("div", null, isLoading ? /*#__PURE__*/ React.createElement("div", {
        className: "cs-message__image-content flex justify-center items-center bg-white"
    }, /*#__PURE__*/ React.createElement("div", {
        role: "status"
    }, /*#__PURE__*/ React.createElement("svg", {
        "aria-hidden": "true",
        className: "inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 loading-fill",
        viewBox: "0 0 100 101",
        fill: "fill-blue-600",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
        fill: "currentFill"
    })), /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, "Loading..."))) : /*#__PURE__*/ React.createElement(Message.ImageContent, {
        src: imageUrl,
        alt: "image"
    }), /*#__PURE__*/ React.createElement("div", {
        ref: messageRef
    }))), /*#__PURE__*/ React.createElement(Message.Footer, {
        sentTime: convertToJapanTime(message.createdTime)
    }));
};
